import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class CfcGroupElectService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following fir163jsync service pattern exactly
  setCFCGroup(
    baseUrl: string,
    returnClobSettingsObj: any,
    ecSaveDtls: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=rhlut5`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Build clob_settings from returnClobSettingsObj
    const clobSettings: any = {
      sso_id: returnClobSettingsObj?.sso_id || globalService?.globalParams?.sso_id || '',
      tax_year: returnClobSettingsObj?.tax_year || filterParams?.tax_year || rowData?.TAX_YEAR || '',
      scenario: returnClobSettingsObj?.scenario || filterParams?.scenario || rowData?.SCENARIO || '',
      jcd_key: returnClobSettingsObj?.jcd_key || filterParams?.jcd_key || rowData?.JCD_KEY || ''
    };
    
    // Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(ecSaveDtls || []);
    const jsonSettings = JSON.stringify(clobSettings);
    
    // Extend with clob_data and clob_settings
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);
    
    // Core parameters with fallbacks from real data
    params.sso_id = returnClobSettingsObj?.sso_id || globalService?.globalParams?.sso_id || '';
    params.tax_year = returnClobSettingsObj?.tax_year || filterParams?.tax_year || rowData?.TAX_YEAR || '';
    params.scenario = returnClobSettingsObj?.scenario || filterParams?.scenario || rowData?.SCENARIO || '';
    params.jcd_key = returnClobSettingsObj?.jcd_key || filterParams?.jcd_key || rowData?.JCD_KEY || globalService?.globalParams?.jcd_key || '';
    params.scenarioCode = 'RAF';
    params.is_issue_key_enabled = 'N';

    // 🚀 CRITICAL: Build checkLockedbj array from ecSaveDtls (multiple entities)
    const checkLockedbj: any[] = [];
    if (ecSaveDtls && ecSaveDtls.length > 0) {
      ecSaveDtls.forEach((item: any) => {
        checkLockedbj.push({
          "leid": item.leid || '',
          "me_code": item.me_code || 'HOELIM',
          "cdr_number": item.cdr_number || item.leid || '',
          "reporting_period": 1,
          "combination_key": parseInt(item.combination_key) || 0,
          "scenario_key": parseInt(filterParams?.scenario || rowData?.SCENARIO || '74')
        });
      });
    }
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Additional required fields
    params.filing_key = filterParams?.filing_key || rowData?.CONSOL_GROUP_KEY || '1';
    params.combination_key = returnClobSettingsObj?.combination_key || '';
    
    // Set process_name based on component
    params.process_name = "CFC_GROUP_ELECT_PROCESS";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const val = params[key];
      if (val !== undefined && val !== null && typeof val !== 'object') {
        urlEncoded.set(key, String(val));
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
